import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
// import { NavigationEnd, Router } from '@angular/router';
import {  NAVIGATIONS_UBI_FRESH, NAVIGATIONS_UBI_FRESH_ADMIN, NAVIGATIONS_UBI_FRESH_MAKER_CHECKER, NAVIGATIONS_UBI_SUPER_ADMIN, withValidationInbox } from './navigation';
// import { AdminAuthService } from './admin-auth.service';
import { environment as ENV } from 'environments/environment';
import { Router } from '@angular/router';
import { AdminAuthService } from 'app/admin/admin-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Component({
  selector: 'wl-fresh-app',
  templateUrl: './fresh-app.component.html',
  styleUrls: ['./fresh-app.component.scss']
})
export class FreshAppComponent implements OnInit {

  watcher: Subscription;
  activeMediaQuery = '';
  sideNav = { mode: 'side', isOpened: true };
  navList: any;
  cName: String;
  demo: any;

  role: string;
  userName: string;
  event$: any;
  userRoleId: string;
  level: any;
  isLoggingOut = false;

  constructor(
    private router: Router,
    private adminAuth: AdminAuthService,
    private snackbar: MatSnackBar,
    private breakpointObserver: BreakpointObserver
  ) {
    // Without this the sidenav stays mode:'side' + opened, so on a phone a
    // 250px drawer permanently pushes the content off-screen. Below Small it
    // becomes an overlay that starts closed, reached via the header menu button.
    // Same logic AdminComponent already uses; this component never had it.
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
    ]).subscribe(result => {
      this.sideNav = result.matches
        ? { mode: 'push', isOpened: false }
        : { mode: 'side', isOpened: true };
    });
  }

  ngOnInit() {
    // this.changeColor(0)
    this.userName = sessionStorage.getItem('userName')
    this.userRoleId = sessionStorage.getItem('getroleId');
    if(this.userRoleId == '1'){
      this.level = 'Central Office';
      this.navList = NAVIGATIONS_UBI_FRESH_ADMIN
    }else if(this.userRoleId == '2'){
      this.level = 'Zonal Admin';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '3'){
      this.level = 'Regional Admin';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '4'){
      this.level = 'Branch Admin';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '5'){
      this.level = 'RDO';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '11'){
      this.level = 'Maker';
      this.navList = NAVIGATIONS_UBI_FRESH_MAKER_CHECKER
    }else if(this.userRoleId == '12'){
      this.level = 'Checker';
      this.navList = NAVIGATIONS_UBI_FRESH_MAKER_CHECKER
    }else if(this.userRoleId == '21'){
      this.level = 'Zone User';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '31'){
      this.level = 'Regional User';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '41'){
      this.level = 'Branch User';
      this.navList = NAVIGATIONS_UBI_FRESH
    }else if(this.userRoleId == '0'){
      this.level = 'Super Admin';
      this.navList = NAVIGATIONS_UBI_SUPER_ADMIN
    }
    else if(this.userRoleId == null){
      this.level='dummy'
      this.navList = NAVIGATIONS_UBI_FRESH_MAKER_CHECKER
    }
    // The role picked the menu above. This adds Branch Validation Inbox to it
    // when the backend says this user is a maker or checker — all the role's
    // own tabs stay exactly as they are.
    this.navList = withValidationInbox(this.navList);

    console.log('navList is:',this.navList);
        console.log('userRoleId is:',this.userRoleId);
        console.log('userName',this.userName);
   
  }

  toggleSubmenu(menuItem) {
    menuItem.isSubmenuVisible = !menuItem.isSubmenuVisible;
    if (menuItem.link) {
      this.router.navigate([menuItem.link]);
    }
  }

  adminLogout() {
    const userId = sessionStorage.getItem('wl-admin-id');
    if (!userId) {
      this.snackbar.open('Failed to logout. User session not found.', 'OK', { duration: 3000 });
      return;
    }
    this.isLoggingOut = true;
    this.adminAuth.logoutFromServer(userId).subscribe(
      () => {
        this.adminAuth.adminLogout();
        window.location.href = '/login-admin';
      },
      (err) => {
        console.error('Logout API failed:', err);
        this.isLoggingOut = false;
        this.snackbar.open('Failed to logout. Please try again.', 'OK', { duration: 3000 });
      }
    );
  }

  changeColor(i){
    for(let i = 0; i<this.navList.length; i++){
      this.navList[i].isSelected = false
    }
    for(let i = 0; i<this.navList.length; i++){
      if(this.navList && this.navList[i] && this.navList[i].submenu){
        for(let m = 0; m<this.navList[i].submenu.length; m++){
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }
    this.navList[i].isSelected = true
  }

  changeColorSubMenu(k,j){
    for(let i = 0; i<this.navList.length; i++){
      this.navList[i].isSelected = false
    }
    for(let i = 0; i<this.navList.length; i++){
      if(this.navList && this.navList[i] && this.navList[i].submenu){
        for(let m = 0; m<this.navList[i].submenu.length; m++){
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }

    this.navList[k].submenu[j].isSubMenuSelected = true
  }

}
